import React, { useEffect, useState } from "react";
import Moment from "@/modules/moment.module";
import { Check, Save } from "lucide-react";
import { cn } from "./utils";
import i18n from "@/i18n";
import Tooltip from "./tooltip";

const { t } = i18n;

const UPDATE_INTERVAL = 3000; // 1 second

const LastSavedIndicator = ({ value }) => {
  let timeoutId;
  const [timeAgo, setTimeAgo] = useState();

  const [justSaved, setJustSaved] = useState(
    () => Date.now() - new Date(value).getTime() < UPDATE_INTERVAL,
  );

  useEffect(() => {
    if (timeoutId) {
      window.clearTimeout(timeoutId);
    }

    setTimeAgo(Moment(value).fromNow());
    setJustSaved(Date.now() - new Date(value).getTime() < UPDATE_INTERVAL);

    timeoutId = setInterval(() => {
      setTimeAgo(Moment(value).fromNow());
      setJustSaved(Date.now() - new Date(value).getTime() < UPDATE_INTERVAL);
    }, UPDATE_INTERVAL);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [value]);

  return (
    <Tooltip value={Moment(value).format("LLL")}>
      <div
        className={cn(
          "flex items-center gap-2 rounded-full border border-slate-100 bg-transparent px-4",
          {
            "animate-wiggle border-success bg-success/10": justSaved,
          },
        )}
      >
        {justSaved ? (
          <Check size={18} className="text-success" />
        ) : (
          <Save size={18} className="text-slate-400" />
        )}
        <span>{justSaved ? t("saved") : `${t("saved")} ${timeAgo}`}</span>
      </div>
    </Tooltip>
  );
};

export default LastSavedIndicator;
